import {
  createStaffRequestEvidenceApi,
  createStaffRequestQuestionsApi,
  createStaffRequestsApi,
} from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import { openDownloadInNewTab, putAttachmentToTarget, type RequestsRuntime } from "./runtime";

/**
 * The runtime of the real admin app: the typed clients over `fetch` and the clock. The bearer token comes from the same function the
 * catalog and the memory pages use. The pages learn the staff id of the signed-in user from `GET /staff/me` (`useRequestViewer`).
 */
export function createAdminRequestsRuntime(): RequestsRuntime {
  const config = getAdminPublicConfig();
  const options = { baseUrl: config.apiUrl.toString(), getAccessToken: currentAccessToken };
  return {
    api: createStaffRequestsApi(options),
    questions: createStaffRequestQuestionsApi(options),
    fulfilment: createStaffRequestEvidenceApi(options),
    uploadFile: (target, file) => putAttachmentToTarget(target, file),
    openDownload: openDownloadInNewTab,
    now: () => new Date(),
  };
}
